export const PAYMENT_LINKS_TRANSACTIONS_APIS = {
  get_payment_links_transactions: "payments/exly/transactions/list",
};
